import React, { useState, useCallback } from "react";
// import logo from './logo.svg';
import "./EnterDataResult.scss";
import GreenButton from "../Components/GreenButton";
import logo from "../Images/ge-healthcare-logo.png";
import { useParams, useNavigate } from "react-router";
import ReturnHome from "../Components/ReturnHome";
import ModalCover from "../Components/ModalCover";
import ModalButtonsDisplay from "../Components/ModalButtonsDisplay";
import getScore from "../Utils/getScore";
import { addDocument } from "../WebMethods/AddDocument";
import viewNavigate from '../Utils/viewNavigate'
import useIdle from "../Hooks/useIdle";

const inputTest = (name) => name.length > 0 && name.length < 26;
const EnterDataResult = (props) => {
  const isIdle = useIdle();
  let navigate = useNavigate();
  const [retunHome, setRetunHome] = useState(false);
  const [firstName, setFirstName] = useState("");
  const goFurther = useCallback(
    async (name) => {
      console.log(name.length);
      if (!inputTest(name)) {
        return;
      }
      const userData = {
        responses: props.responses,
        totalScore: getScore(props.responses),
        userName: name,
      };
      props.setUserData(userData);
      const res = await addDocument("answers", userData);
      viewNavigate(navigate, `/Leaderbord`);
    },
    [props.responses]
  );
  return (
    <div className="holder-enter">
      <div className="container-enter">
        <img src={logo} alt="GE HealthCare" className="logo-enter" />
        <div className="distance-enter"></div>
        <p className="main-title-enter">Choose Your Leaderboard Name:</p>
        <input
          placeholder="Jane Smith"
          className="input-enter"
          type="text"
          id="lname"
          name="lname"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <GreenButton
          disabled={!inputTest(firstName)}
          onClick={() => {
            goFurther(firstName);
            // viewNavigate(navigate, `/Leaderbord`);
          }}
        >
          Go to Leaderboard
        </GreenButton>
      </div>
      {/* <ViewLottie /> */}
      <div className="bottom-actions-enter">
        <ReturnHome onClick={() => setRetunHome(true)} />
      </div>
      {retunHome && (
        <ModalCover>
          <ModalButtonsDisplay
            title={"Are you sure?"}
            text={"The game will end, and you can start a new session."}
            denyText={"Cancel"}
            deny={() => {
              setRetunHome(false);
            }}
            accept={() => {
              viewNavigate(navigate, `/`);
            }}
            acceptText={"Retun To Home"}
          />
        </ModalCover>
      )}
    </div>
  );
};
export default EnterDataResult;
